import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../reducers";
import ModalConfirm from "../../../../components/Modals/Generales/ModalConfirm";
import { gp_ap_ShowModalConfirmacion } from "../../../../actions/gestion-producto/agregar-producto/agregarProducto.actions";
import ModalProductoCreated from "./ModalProductoCreated";
import { bindActionCreators } from "redux";
import { actionsGPAgregarProducto } from "../../../../actions/action-creators";

const ModalsControls = () => {
    const {activoConfirmacion, activoConfirmar, activoCreado} = useSelector(
        (state: State) => state.gestionProducto.agregarProducto.modals
    )
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionsGPAgregarProducto, dispatch)
    const sucursales = useSelector(
        (state: State) => state.gestionProducto.agregarProducto.sucursalesAsignadas
    )

    const closeModalConfirm = async () => {
        await dispatch(gp_ap_ShowModalConfirmacion(false))
    }

    return(
        <>
            {activoConfirmar && (
                <ModalConfirm
                    title={'Confirmar nuevo producto'}
                    detail={
                        sucursales.length === 0
                        ? 'Estás a punto de crear un nuevo producto sin asociarle ninguna sucursal ¿Deseas continuar?'
                        : 'Estás a punto de crear un nuevo producto, ¿Deseas continuar?'
                    }
                    actionConfirm={actions.gp_ap_agregarProducto}
                    closeModalConfirm={closeModalConfirm}
                    Styles={{maxWidth: '500px'}}
                />
            )}
            {activoCreado && <ModalProductoCreated />}
        </>
    )
}

export default ModalsControls;